export var dashboard = {
  name: "首页",
  path: "/dashboard",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "1",
  sort: 1,
  alwaysShow: true,
  meta: {
    title: "首页",
    icon: "dashboard",
    noCache: false
  },
  children: [{
    name: "Dashboard",
    path: "/dashboard",
    hidden: false,
    component: "dashboard/index",
    elemCode: "2",
    meta: {
      title: "首页",
      noCache: true
    }
  }]
};